import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class DefaultScheduleService {

  constructor(private http: HttpClient) { }

  createUpdateSchedule(scheduleForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `default-schedule/save_update_default_schedule`, scheduleForm, OPTIONS);
  }

  getDefaultSchedules() {
    return this.http.get<any>(Library.API_ENDPOINT + 'default-schedule/get_default_schedules', OPTIONS);
  }

  getDefaultSchedulesRange() {
    return this.http.get<any>(Library.API_ENDPOINT + 'default-schedule/get_default_schedules_range', OPTIONS);
  }

  getDefaultSchedulesEmployee(employeeId: number) {
    return this.http.get<any>(Library.API_ENDPOINT + `default-schedule/get_default_schedules_employee/${employeeId}`, OPTIONS);
  }

  generateEmployeeWorkdays(processForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'default-schedule/generate_employee_workdays', processForm, OPTIONS);
  }

  createUpdateScheduleLine(elementForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `default-schedule/save_update_schedule_line`, elementForm, OPTIONS);
  }

  deleteDefaultSchedule(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `default-schedule/delete_default_schedule/${id}`, OPTIONS);
  }

  deleteScheduleLine(selectedIds: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `default-schedule/delete_schedule_line`, selectedIds, OPTIONS);
  }

  create_workdays_schedule(processForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'default-schedule/create_workdays_schedule', processForm, OPTIONS);
  }
}
